import { type ApiPaths, type RequestQuery, apiFetch } from '~/src/shared/api';

export async function sendVerificationCode(query: RequestQuery<ApiPaths['/v1']['/verification-codes']['post']>) {
  await apiFetch('/v1/verification-codes', {
    method: 'POST',
    query,
  });
}
